import type { BlockRaw } from 'shared-types';

type LocaleData = BlockRaw['locales'][string];

const defaultBlockData = {
  format: 'html' as const
};

const translatable: LocaleData['translatable'] = { text: '' };
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockRawData: BlockRaw = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockRaw['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
